/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [sidebar-entry-date.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 13.02.20, 11:50
 */

import React from 'react';
import {BoxedLink} from "../../navigation/buttons/nav-buttons";
import {ImageBoxSmall} from "../../boxes/image-box-small";
import {NavigationGroup, NavigationRow} from "../../navigation/layout/nav-layout";
import {formatLongFns, formatShortFns} from "../../configuration/configuration";
import {TodayOutlined} from "@material-ui/icons";
import {EventEndIcon} from "../../navigation/icons/nav-icons";


const SidebarSimpleEntryEvent = ({peekspace, left}) => {
    const activeSpace = `/${peekspace.username}/space/${peekspace.id}`;
    const isBlocked = peekspace.state === 'BLOCKED';

    return <div className='sidebar-entry-event mt-1 mb-2'>
        <NavigationRow left className='sidebar-entry-date align-items-start'>

            <NavigationGroup>
                <BoxedLink to={activeSpace}>
                    <ImageBoxSmall size='medium' image={peekspace.url}/>
                </BoxedLink>
            </NavigationGroup>
            
            <NavigationGroup className='px-1'>
                <BoxedLink to={activeSpace}>
                    <div className='mr-1'>
                        <div className='sidebar-space-date fw-bolder text-danger'>
                            <TodayOutlined className='font-1x'/> {formatShortFns(peekspace.calendarDate.date)}
                        </div>
                        {peekspace.calendarDateEnd && <div className='sidebar-space-date fw-bolder text-danger'>
                            <EventEndIcon xsmall={true}/>{formatShortFns(peekspace.calendarDateEnd.date)}
                        </div>}
                        <div className='sidebar-space-text lh-1'>{peekspace.name}</div>
                        {isBlocked && <span className='badge bg-danger rounded-pill small'>Cancelled</span>}
                    </div>
                </BoxedLink>
            </NavigationGroup>


        </NavigationRow>
    </div>
}

export default SidebarSimpleEntryEvent;
